Bingo.OfferFilterForm = Bingo.OfferFilterForm || {};

Bingo.OfferFilterForm.clearLocationFields = function () {
    $(this.formSelector).find('#location').val('');
    $(this.formSelector).find('#location').prop('placeholder', 'Enter a location');
    $(this.formSelector).find('#coordinates').val('');
    $(this.formSelector).find('#polygon').val('');
};

Bingo.OfferFilterForm.doFilter = function () {
    $(this.formSelector).find('button[name=filter]').click();
};

Bingo.OfferFilterForm.hideOptionsSwitch = function () {
    const optionsSwitchTitle = $('.map-options-switch-title');
    const optionsSwitchTitleSpan = $('.map-options-switch-title span');
    const optionsSwitchOptionsCover = $('.options-cover');
    let optionsSwitchOpened = true;
    optionsSwitchTitleSpan.attr('data-hide-text', optionsSwitchTitleSpan.text());
    optionsSwitchTitle.on('click', () => {
        if (optionsSwitchOpened) {
            optionsSwitchTitle.css('width', optionsSwitchTitle.outerWidth());
            optionsSwitchTitleSpan.text(optionsSwitchTitleSpan.attr('data-show-text'));
            optionsSwitchOptionsCover.hide();
            optionsSwitchOpened = false;
        } else {
            optionsSwitchTitleSpan.text(optionsSwitchTitleSpan.attr('data-hide-text'));
            optionsSwitchOptionsCover.show();
            optionsSwitchOpened = true;
        }
    });
};

Bingo.OfferFilterForm.setPositionForOptionsDropdown = function (mapId) {
    const googleMapPosition = $(mapId).offset();
    const mapOptionsSwitch = $('.map-options-switch');
    const margin = parseInt(mapOptionsSwitch.css('left'), 10);

    if (googleMapPosition.top > 0) {
        mapOptionsSwitch.css({
            top: googleMapPosition.top + margin,
        });
    }
};

Bingo.OfferFilterForm.formSelector = $('#frm-offerSearch-offerFilterForm-form');
